import * as z from 'zod';

import { OptionalPhoneNumber } from '../../Phone';
import { MiCompanyCode } from './miCompanyCodes';

// Service bureau code for an in-house lender/servicer; the report builder falls back to this when
// no per-insurer value is configured. A carrier may still require a real bureau code or an empty
// value, so `serviceBureauCodes` is keyed per MI company (observed in production: MGIC 027, Enact
// 999, Arch/Radian blank).
export const DEFAULT_IN_HOUSE_LENDER_BUREAU_CODE = '999';

// Per-company mortgage-insurance file-identity settings. `clientNumbers` and `serviceBureauCodes`
// are keyed by MI company code because each insurer assigns its own values to a servicer at
// onboarding.
export const MiSettings = z.object({
  serviceBureauCodes: z.partialRecord(MiCompanyCode, z.string()).optional(),
  clientNumbers: z.partialRecord(MiCompanyCode, z.string()).optional(),
  servicingContactName: z.string().optional(),
  servicingContactPhone: OptionalPhoneNumber,
  subServicerCode: z.string().optional(),
  servicerIds: z.partialRecord(MiCompanyCode, z.string()).optional(),
});
export type MiSettings = z.infer<typeof MiSettings>;
